import React from "react";
import { GR, GB, US, IT } from "country-flag-icons/react/1x1";

export function getFlag(input) {
  switch (input) {
    case "GR":
      return <GR />;
    case "EN-GB":
      return <GB />;
    case "EN-US":
      return <US />;
    case "IT":
      return <IT />;
    default:
      return null;
  }
}

export function getCurrency(input) {
  switch (input) {
    case "EUR":
      return "ic:round-euro";
    case "GBP":
      return "mdi:currency-gbp";
    case "USD":
      return "bx:dollar";
    case "CAD":
      return "bx:dollar";
    case "CNY":
      return "bx:yen";
    case "HKD":
      return "bx:yen";
    case "AUD":
      return "bx:dollar";
    case "MXN":
      return "bx:dollar";
    case "ZAR":
      return "R";
    case "BRL":
      return "mdi:currency-brl";
    default:
      return null;
  }
}
